import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { settingsModel } from '../../../models/service/settings.model';
import { costModel } from '../../../models/core/cost.model';
import { controlModel } from '../../../models/core/control.model';
import { composeSpinner } from '../../../hoc/composeSpinner';

import { DATEPICKER_FORMAT, REFRESH_TIMEOUT_10_SEC, REFRESH_TIMEOUT_60_SEC } from '../../../constants/data.constant';
import { GLOBAL_TYPES } from '../../../device/types/global.types';
import { getCurrentDate } from '../../../services/service/settings.selectors';
import { convertDateToFromToByType, calcDateByType } from '../../../services/core/cost/cost.helper';
import { setCostDate, setCostType } from '../../../actions/cost.actions';

let energySumTimerId = null;
let energyChartDataTimerId = null;

class CostContainer extends Component {
    constructor(...args) {
        var _temp;

        return _temp = super(...args), this._getCurrentDate = () => {
            return this.props.costState.date || this.props.currentDate;
        }, this._refreshEnergySum = (pause = REFRESH_TIMEOUT_60_SEC) => {
            clearTimeout(energySumTimerId);
            energySumTimerId = setTimeout(this._loadEnergySum, pause);
        }, this._refreshEnergyChartData = (pause = REFRESH_TIMEOUT_60_SEC) => {
            clearTimeout(energyChartDataTimerId);
            energyChartDataTimerId = setTimeout(this._loadEnergyChartData, pause);
        }, this._loadEnergyChartData = (date = null) => {
            this._refreshEnergyChartData();
            if (!this.props.costData.chart.isLoading) {
                date = date || this._getCurrentDate();
                const { to, from } = convertDateToFromToByType(date, this.props.costState.type);
                this.props.handleGetEnergyChartData({
                    to,
                    from,
                    type: this.props.costState.type,
                    items: this.props.controlsData.items
                });
            }
        }, this._loadEnergySum = (date = null) => {
            this._refreshEnergySum();
            if (!this.props.costData.energy.isLoading) {
                date = date || this._getCurrentDate();
                const { to, from } = convertDateToFromToByType(date, this.props.costState.type);
                this.props.handleGetEnergySum({
                    to,
                    from,
                    costMode: this.props.settings.settings[GLOBAL_TYPES.COST_MODE]
                });
            }
        }, this.handleGetPrev = () => {
            const currentDate = this._getCurrentDate();
            const date = calcDateByType(currentDate, this.props.costState.type, -1);
            this.props.handleSetCostDate(date);
        }, this.handleGetNext = () => {
            const currentDate = this._getCurrentDate();
            const date = calcDateByType(currentDate, this.props.costState.type);
            this.props.handleSetCostDate(date);
        }, this.handleChartType = type => {
            this.props.handleSetCostType(type);
        }, this.handleDateChange = newDate => {
            const date = moment(newDate, DATEPICKER_FORMAT).toDate();
            date.setHours(0, 0, 0, 0);
            this.props.handleSetCostDate(date);
        }, _temp;
    }

    componentDidMount() {
        setTimeout(() => {
            this._loadEnergySum();
        }, 0);
        setTimeout(() => {
            this._loadEnergyChartData();
        }, 0);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.costState.date !== prevProps.costState.date) {
            this.startTime();
            this._loadEnergySum(this.props.costState.date);
            this._loadEnergyChartData(this.props.costState.date);
        }

        if (this.props.costState.type !== prevProps.costState.type) {
            const date = this.props.costState.date || this._getCurrentDate();
            const { to, from } = convertDateToFromToByType(date, this.props.costState.type);
            this.handleDateChange(from);
        }

        if (prevProps.costData.chart.isLoading || prevProps.costData.energy.isLoading) {
            if (!this.props.costData.chart.isLoading && !this.props.costData.energy.isLoading) {
                this.clearSpinner();
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(energySumTimerId);
        energySumTimerId = null;
        clearTimeout(energyChartDataTimerId);
        energyChartDataTimerId = null;
    }

    render() {
        return null;
    }
}

export const CostContainerCore = composeSpinner(CostContainer);

export const mapStateToPropsCore = (state, props) => {
    const currentDate = getCurrentDate(state);

    return {
        currentDate,
        costModel,
        costState: state.costReducer,
        controlsData: state.control[controlModel.MODEL_NAME],
        costData: state.cost[costModel.MODEL_NAME],
        settings: state.settings[settingsModel.MODEL_NAME]
    };
};

export const mapDispatchToPropsCore = (modelGet, apiGetEnergySum) => dispatch => {
    return {
        handleSetCostType: bindActionCreators(setCostType, dispatch),
        handleSetCostDate: bindActionCreators(setCostDate, dispatch),
        handleGetEnergySum: bindActionCreators(apiGetEnergySum, dispatch),
        handleGetEnergyChartData: bindActionCreators(modelGet(costModel), dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/core/Cost.container.js